// Specific errors for ims object collections
/**
 * A negative ID (i.e. local ims object, aka temp client side object) has been requested but not
 * been found. Often times this comes up when a panel with a negative ID is open
 * and then IMS frontend is refreshed. The refreshed frontend will attempt to open a
 * negative ID which does not exist, and thus error.
 */
export class LocalIMSObjectNotFound extends Error {
    constructor(message?: string) {
        super(message);
        // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
        this.name = LocalIMSObjectNotFound.name; // stack traces display correctly now
    }
}
